import { COMPONENT_MAP_NAMES } from './consts';
import { ONBOARDING_VIEWS_MAP, ONBOARDING_VIEWS_MAP_ROUTES } from './InvoiceOnboarding/consts/consts';

export const shouldShowInvoiceOnboarding = (createInvoice: boolean, finishCustomization: boolean) => !createInvoice && !finishCustomization;
export const getActiveInvoicePage = (createInvoice: boolean, finishCustomization: boolean) => {
  if (shouldShowInvoiceOnboarding(createInvoice, finishCustomization)) return COMPONENT_MAP_NAMES.ONBOARDING;
  return COMPONENT_MAP_NAMES.HUB;
};

export const isAnEmptyObject = (obj: any) => obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const validateInitialStep = (initialStep: string) => {
  const validRoutes = ['logo', 'color', 'payment-details', 'payment-options'];
  return validRoutes.includes(initialStep);
};

export const getInitialStepNumberFromRoutePath = (routePath: string) => {
  if (routePath === ONBOARDING_VIEWS_MAP_ROUTES.LOGO) return ONBOARDING_VIEWS_MAP.LOGO;
  if (routePath === ONBOARDING_VIEWS_MAP_ROUTES.COLOR) return ONBOARDING_VIEWS_MAP.COLOR;
  if (routePath === ONBOARDING_VIEWS_MAP_ROUTES.DETAILS) return ONBOARDING_VIEWS_MAP.DETAILS;
  if (routePath === ONBOARDING_VIEWS_MAP_ROUTES.PAYMENTS) return ONBOARDING_VIEWS_MAP.PAYMENTS;
  return 0;
};

export const ONBOARDING_ROUTES_TO_VIEWS_MAP = {
  logo: [ONBOARDING_VIEWS_MAP.LOGO],
  color: [ONBOARDING_VIEWS_MAP.COLOR],
  'payment-details': [ONBOARDING_VIEWS_MAP.DETAILS],
  'payment-options': [ONBOARDING_VIEWS_MAP.PAYMENTS],
};
